import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function ResetPasswordPage() {
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(false)
  const [ready, setReady] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    // Supabase embeds the recovery token in the URL hash.
    // onAuthStateChange fires PASSWORD_RECOVERY when it detects this —
    // that's our signal the session is valid and the form can be shown.
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'PASSWORD_RECOVERY' || (event === 'SIGNED_IN' && session)) {
        setReady(true)
      }
    })

    // Also check if we already have a session (e.g. page reload)
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) setReady(true)
    })

    return () => subscription.unsubscribe()
  }, [])

  async function handleReset(e) {
    e.preventDefault()
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return }
    if (password !== confirm) { setError('Passwords do not match.'); return }
    setLoading(true)
    setError(null)
    const { error } = await supabase.auth.updateUser({ password })
    setLoading(false)
    if (error) { setError(error.message); return }
    setSuccess(true)
    // Sign out so they log in fresh with new password
    setTimeout(async () => {
      await supabase.auth.signOut()
      navigate('/login')
    }, 2000)
  }

  if (success) {
    return (
      <div className="auth-wrap">
        <div className="auth-card">
          <div className="auth-logo">Powered by <span>Rebound</span></div>
          <div className="alert alert-success" style={{ marginBottom: 20 }}>
            Password updated. Taking you to login…
          </div>
        </div>
      </div>
    )
  }

  if (!ready) {
    return (
      <div className="auth-wrap">
        <div className="auth-card">
          <div className="auth-logo">Powered by <span>Rebound</span></div>
          <p className="text-muted" style={{ textAlign: 'center', marginBottom: 16 }}>Validating reset link…</p>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <span className="spinner" style={{ width: 20, height: 20 }} />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <div className="auth-logo">Powered by <span>Rebound</span></div>
        <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 6 }}>Set new password</div>
        <p className="text-muted fs12" style={{ marginBottom: 20 }}>Choose a new password for your account.</p>
        {error && <div className="alert alert-error" style={{ marginBottom: 16 }}>{error}</div>}
        <form onSubmit={handleReset}>
          <div className="field">
            <label>New Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Min. 8 characters" required minLength={8} autoFocus />
          </div>
          <div className="field" style={{ marginBottom: 20 }}>
            <label>Confirm Password</label>
            <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Repeat password" required />
          </div>
          <button className="btn btn-primary btn-full" type="submit" disabled={loading}>
            {loading ? <><span className="spinner" />&nbsp;Updating…</> : 'Update Password'}
          </button>
        </form>
      </div>
    </div>
  )
}
